import styled, { css } from 'styled-components';

import type { Maybe } from '@/lib/types';

import type { VisibilityProps } from './Visibility';

export const getVisibility = (
  handleDisplay: Maybe<boolean>,
  handleVisibility: Maybe<boolean>,
  visible?: boolean,
) =>
  visible &&
  css`
    ${handleDisplay &&
    css`
      display: block;
    `}
    ${handleVisibility &&
    css`
      visibility: visible;
    `}
  `;

export const getInvisibility = (
  handleDisplay: Maybe<boolean>,
  handleVisibility: Maybe<boolean>,
  hidden?: boolean,
) =>
  hidden &&
  css`
    ${handleDisplay &&
    css`
      display: none;
    `};
    ${handleVisibility &&
    css`
      visibility: hidden;
    `}
  `;

export const Wrapper = styled.div<VisibilityProps>`
  ${({
    handleDisplay,
    handleVisibility,
    lgHidden,
    lgVisible,
    mdHidden,
    mdVisible,
    smHidden,
    smVisible,
    theme: { mediaQueries },
    xlHidden,
    xlVisible,
    xsHidden,
    xsVisible,
  }) =>
    css`
      width: 100%;
      display: flex;
      justify-content: center;
      ${getVisibility(
        handleDisplay,
        handleVisibility,
        xsHidden || smHidden || mdHidden || lgHidden || xlHidden,
      )};
      ${getInvisibility(
        handleDisplay,
        handleVisibility,
        xsVisible || smVisible || mdVisible || lgVisible || xlVisible,
      )};

      ${getVisibility(handleDisplay, handleVisibility, xsVisible)};
      ${getInvisibility(handleDisplay, handleVisibility, xsHidden)};

      ${mediaQueries.sm} {
        ${getVisibility(handleDisplay, handleVisibility, smVisible)};
        ${getInvisibility(handleDisplay, handleVisibility, smHidden)};
      }
      ${mediaQueries.md} {
        ${getVisibility(handleDisplay, handleVisibility, mdVisible)};
        ${getInvisibility(handleDisplay, handleVisibility, mdHidden)};
      }
      ${mediaQueries.lg} {
        ${getVisibility(handleDisplay, handleVisibility, lgVisible)};
        ${getInvisibility(handleDisplay, handleVisibility, lgHidden)};
      }
      ${mediaQueries.xl} {
        ${getVisibility(handleDisplay, handleVisibility, xlVisible)};
        ${getInvisibility(handleDisplay, handleVisibility, xlHidden)};
      }
    `}
`;
